import { apiClient } from '@/shared/api'

import { TEvent } from '../model/schema'

type GetEventsParams = {
  onlyGuestEvent?: boolean
  onlyHostEvent?: boolean
}

type GetEventsResponse = {
  inProgressEvents: TEvent[]
  closedEvents: TEvent[]
}

export const getEvents = async (params: GetEventsParams = {}) => {
  const { data } = await apiClient.get<GetEventsResponse>({
    endpoint: '/campaigns/events',
    queryParams: params,
  })

  return data
}
